<template>
  <div class="calico-form-header-page">
    <calico-required-form-header />
  </div>
</template>
  
  <script lang="js">
  import CalicoRequiredFormHeader from '@/components/calico/formHeader/index.vue'
  export default {
    name: 'CalicoFormHeaderPage',
    components: {
        CalicoRequiredFormHeader
    },
    data () {
      return {
        text1: '',
      }
    },
  }
  </script>
  <style lang="scss">
  .calico-form-header-page {
    @include stack-space($space-large);
    @include inset-space($space-large);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  </style>
  